import * as E from "~/renderer/web-components/element";

export class ScrollView extends E.SFMLElement {
  constructor() {
    super();
  }
}
customElements.define("sfml-scrollview", ScrollView);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/layout/scrollview.ts